import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Paper } from "@mui/material";
import { setAlert } from "./../../action/alert";
import { connect } from "react-redux";
import "./DeviceUpdateLogs.css";
import { getDeviceLogsData } from "./../../action/devicelogs";
import Moment from "react-moment";
import Alert from "../layout/Alert";
import DataTable from "../Common/DataTable/DataTable";
import EmptyState from "../Common/EmptyState/EmptyState";

const DeviceUpdateLogs = ({ deviceDetails, setCustomAlert }) => {
  const headers = {
    serialNumber: "S.No",
    activity: "Actions",
    timestamp: "Timestamp",
    productSerialNumber: "Product Serial Number",
    macAddress: "MAC Address",
    status: "Status",
  };

  const [deviceLogsData, setDeviceLogsData] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const updateDeviceLogsData = (resolveFunc, errFunc) => {
    setIsLoading(true);
    getDeviceLogsData(deviceDetails?.deviceId ?? "")
      .then((res) => {
        setIsLoading(false);
        if (!resolveFunc) {
          setDeviceLogsData(res);
        } else {
          resolveFunc(res);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (!errFunc) {
          console.log(err);
          setCustomAlert("Error while fetching device logs data.", "danger");
          setDeviceLogsData([]);
        } else {
          errFunc(err);
        }
      });
  };

  useEffect(() => {
    if (
      deviceDetails &&
      deviceDetails instanceof Object &&
      deviceDetails.hasOwnProperty("deviceId")
    ) {
      updateDeviceLogsData();
    }
  }, [deviceDetails]);

  useEffect(() => {
    if (updateFlag) {
      updateDeviceLogsData();
    }
  }, [updateFlag]);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          minHeight: "40vh",
          mt: 2,
          mb: 2,
          py: 2,
        }}
      >
        <CircularProgress size={60} sx={{ color: "#AFB42B" }} />
      </Box>
    );
  }

  const deviceUpdateLogColumns = Object.keys(headers).map((key) => ({
    key,
    label: headers[key],
    minWidth: key === "productSerialNumber" ? 220 : 160,
    headerCellSx: {
      fontWeight: 600,
      backgroundColor: "background.paper",
      whiteSpace: "nowrap",
    },
    render: (value, row) => {
      const cellValue = key === "serialNumber" ? row.serialNumber : value;
      const strVal = String(cellValue || "");
      const breakWord = key !== "serialNumber" && strVal.length > 200;

      if (key === "timestamp") {
        return strVal && strVal.length > 0 ? (
          <Box className={strVal.length > 60 ? "breakWord" : ""}>
            <Moment format="DD-MM-YYYY HH:mm:ss" date={value} />
          </Box>
        ) : (
          ""
        );
      }

      return (
        <Box className={breakWord ? "breakWord" : strVal.length > 60 ? "breakWord" : ""}>
          {cellValue || ""}
        </Box>
      );
    },
  }));

  const deviceUpdateLogRows = deviceLogsData.map((element, index) => ({
    ...element,
    rowId: `${element?.timestamp || "log"}-${index}`,
    serialNumber: index + 1,
  }));
  const hasDeviceLogData = Array.isArray(deviceUpdateLogRows) && deviceUpdateLogRows.length > 0;

  return (
    <Box sx={{ width: "100%", minWidth: 0, mt: 2, mb: 2 }}>
      <Alert />
      <Paper
        sx={{
          p: 2,
          boxShadow: 2,
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        {!hasDeviceLogData ? (
          <EmptyState
            message="No Data found"
            sx={{ bgcolor: "transparent", p: 0 }}
          />
        ) : (
          <DataTable
            columns={deviceUpdateLogColumns}
            data={deviceUpdateLogRows}
            rowKey="rowId"
            minWidth="100%"
            maxHeight="58vh"
            striped={false}
            hoverEffect={false}
            tableContainerSx={{ boxShadow: "none", borderRadius: 0, width: "100%", minWidth: 0 }}
            sx={{ scrollBehavior: "auto" }}
            msgForDisplay="No Data found"
          />
        )}
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setCustomAlert: (message, alertType) =>
    dispatch(setAlert(message, alertType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUpdateLogs);
